<template>
<div>
    <v-alert text prominent dense type="error" v-if="mensaje">
        {{mensaje}}
    </v-alert>
    <v-card class="pa-2 " color="grey lighten-2" outlined tile v-else>
        <v-container>
            <v-row justify="space-around">
                <v-col cols="12" sm="12" md="12" style="min-heigth:80px" v-for="(item, i) in diagnosticos" :key="i">
                    <v-sheet min-height="100%" width="100%">
                        <v-container fluid class="pa-0">
                            <v-row align="center" no-gutters class="text-center" style="min-height:80px">
                                <v-col cols="12" sm="12" md="6">
                                    <p>{{item.cie10.comaNombrelargo}} </p>
                                </v-col>
                                <v-divider light class="mx-1" vertical></v-divider>
                                <v-col cols="12" sm="12" md="3">
                                    <p>{{item.clase.comaNombrelargo}} </p>
                                </v-col>
                                <v-divider light class="mx-1" vertical></v-divider>
                                <v-col cols="12" sm="12" md="2">
                                    <p>{{ item.diagnostico.comaNombrelargo}} </p>
                                </v-col>

                            </v-row>
                        </v-container>
                    </v-sheet>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</div>
</template>

<script>
export default {
    props: {
        diagnosticos: Array,
    },
    data() {
        return {
            token: this.$cookies.get("token"),
            mensaje: null,
        };
    },
    created: async function () {
        if (this.diagnosticos.length == 0) {
            this.mensaje = "No se ah registrado ningun diagnostico"
        }
    }
};
</script>

<style>

</style>
